// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Faq_container__4PRrc {
  padding-top: 125px;
  margin: 0 auto;
}
.Faq_container__4PRrc .Faq_title__-bl5\\+ {
  font-size: 32px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 32px;
  text-align: center;
}
.Faq_container__4PRrc .Faq_item__wsIel {
  margin-bottom: 24px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd {
  font-size: 24px;
  font-weight: 500;
  font-style: normal;
  color: #ffffff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  gap: 15px;
  padding-bottom: 18px;
  padding-top: 18px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd .Faq_arrow__2io\\+B {
  align-items: center;
  background-color: #333217;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 40px;
  transition: all 0.2s linear;
  min-width: 40px;
  width: 40px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd .Faq_arrow__2io\\+B img {
  width: 24px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd .Faq_arrow__2io\\+B:hover {
  background-color: #494711;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd.Faq_active__Kzfgu {
  border-bottom: unset;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
  color: #E0E0E0;
  display: none;
  line-height: 150%;
  padding-bottom: 24px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN {
  display: flex;
  gap: 20px;
  margin-top: 16px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN .Faq_tg__u\\+o5S {
  align-items: center;
  background-color: #19334F;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  width: 64px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN .Faq_tg__u\\+o5S:hover {
  background-color: #244971;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN .Faq_phone__IAL6W {
  align-items: center;
  background-color: #3A2159;
  border-radius: 8px;
  color: #AE6FFF;
  display: flex;
  gap: 8px;
  justify-content: center;
  height: 56px;
  transition: all 0.2s linear;
  padding-right: 8px;
  padding-left: 8px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN .Faq_phone__IAL6W:hover {
  background-color: #4A2C6F;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA.Faq_rockets__o8yDx {
  border: none;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA.Faq_open__KX1f5 {
  display: block;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_link__BqmOc {
  color: #00D68F;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_listItem__1Pbv- {
  display: flex;
  gap: 8px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_listItem__1Pbv- .Faq_listImg__MDkiq {
  height: 24px;
  width: 8px;
}
.Faq_container__4PRrc .Faq_item__wsIel .Faq_listItemBig__BHEMI {
  align-items: baseline;
}
.Faq_container__4PRrc .Faq_item__wsIel.Faq_rockets__o8yDx {
  margin-bottom: 0;
  border-bottom: 1px solid rgba(220, 220, 220, 0.1);
}

@media (max-width: 850px) {
  .Faq_container__4PRrc .Faq_title__-bl5\\+ {
    margin-bottom: 40px;
  }
}
@media (max-width: 500px) {
  .Faq_container__4PRrc .Faq_title__-bl5\\+ {
    margin-bottom: 40px;
  }
  .Faq_container__4PRrc .Faq_item__wsIel .Faq_question__kKoqd {
    font-size: 20px;
  }
  .Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA {
    font-size: 16px;
  }
  .Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_paragraph__bJ-rb {
    margin-bottom: 8px;
  }
  .Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_listItem__1Pbv- {
    margin-bottom: 8px;
  }
  .Faq_container__4PRrc .Faq_item__wsIel .Faq_answer__BWCvA .Faq_help__e-GaN {
    gap: 16px;
  }
}
.Faq_no_padding_top__SIfi3 {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Faq/Faq.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,cAAA;AADF;AAGE;EACE,eAAA;EACA,gBAAA;EAEA,cAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAKE;EACE,mBAAA;AAHJ;AAKI;ECOF,eAAA;EACA,gBAAA;EACA,kBAAA;EDNI,cAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AAFN;AAIM;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;AAFR;AAIQ;EACE,WAAA;AAFV;AAIQ;EACE,yBAAA;AAFV;AAOI;EACE,oBAAA;AALN;AAQI;ECVF,eAAA;EACA,gBAAA;EACA,kBAAA;EDWI,iDAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AALN;AAOM;EACE,aAAA;EACA,SAAA;EACA,gBAAA;AALR;AAOQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,WAAA;AALV;AAOU;EACE,yBAAA;AALZ;AASQ;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,iBAAA;AAPV;AASU;EACE,yBAAA;AAPZ;AAaI;EACE,YAAA;AAXN;AAcI;EACE,cAAA;AAZN;AAeI;EACE,cAAA;AAbN;AAgBI;EACE,aAAA;EACA,QAAA;AAdN;AAgBM;EACE,YAAA;EACA,UAAA;AAdR;AAkBI;EACE,qBAAA;AAhBN;AAoBE;EACE,gBAAA;EACA,iDAAA;AAlBJ;;AAsBA;EAGI;IACE,mBAAA;EArBJ;AACF;AAyBA;EAGI;IACE,mBAAA;EAzBJ;EA8BI;IACE,eAAA;EA5BN;EA+BI;IACE,eAAA;EA7BN;EA+BM;IACE,kBAAA;EA7BR;EAgCM;IACE,kBAAA;EA9BR;EAiCM;IACE,SAAA;EA/BR;AACF;AAqCA;EACE,cAAA;AAnCF","sourcesContent":["@use 'assets/styles/global.scss' as *;\n\n.container {\n  padding-top: 125px;\n  margin: 0 auto;\n\n  .title {\n    font-size: 32px;\n    font-weight: 700;\n\n    color: #ffffff;\n    margin-bottom: 32px;\n    text-align: center;\n  }\n\n  .item {\n    margin-bottom: 24px;\n\n    .question {\n      @include subtitle2m;\n\n      color: #ffffff;\n      cursor: pointer;\n      display: flex;\n      justify-content: space-between;\n      gap: 15px;\n      padding-bottom: 18px;\n      padding-top: 18px;\n\n      .arrow {\n        align-items: center;\n        background-color: #333217;\n        border-radius: 8px;\n        display: flex;\n        justify-content: center;\n        height: 40px;\n        transition: all .2s linear;\n        min-width: 40px;\n        width: 40px;\n\n        img {\n          width: 24px;\n        }\n        &:hover {\n          background-color: #494711;\n        }\n      }\n    }\n\n    .question.active {\n      border-bottom: unset;\n    }\n\n    .answer {\n      @include subtitle5;\n\n      border-bottom: 1px solid rgba(220, 220, 220, .1);\n      color: #E0E0E0;\n      display: none;\n      line-height: 150%;\n      padding-bottom: 24px;\n\n      .help {\n        display: flex;\n        gap: 20px;\n        margin-top: 16px;\n\n        .tg {\n          align-items: center;\n          background-color: #19334F;\n          border-radius: 8px;\n          display: flex;\n          justify-content: center;\n          height: 56px;\n          transition: all .2s linear;\n          width: 64px;\n    \n          &:hover {\n            background-color: #244971;\n          }\n        }\n    \n        .phone {\n          align-items: center;\n          background-color: #3A2159;\n          border-radius: 8px;\n          color: #AE6FFF;\n          display: flex;\n          gap: 8px;\n          justify-content: center;\n          height: 56px;\n          transition: all .2s linear;\n          padding-right: 8px;\n          padding-left: 8px;\n    \n          &:hover {\n            background-color: #4A2C6F;\n          }\n        }\n      }\n    }\n\n    .answer.rockets {\n      border: none;\n    }\n\n    .answer.open {\n      display: block;\n    }\n\n    .link {\n      color: #00D68F;\n    }\n\n    .listItem {\n      display: flex;\n      gap: 8px;\n\n      .listImg {\n        height: 24px;\n        width: 8px;\n      }\n    }\n\n    .listItemBig {\n      align-items: baseline;\n    }\n  }\n\n  .item.rockets {\n    margin-bottom: 0;\n    border-bottom: 1px solid rgba(220, 220, 220, .1);\n  }\n}\n\n@media (max-width: 850px) {\n  .container {\n\n    .title {\n      margin-bottom: 40px;\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n\n    .title {\n      margin-bottom: 40px;\n    }\n\n    .item {\n\n      .question {\n        font-size: 20px;\n      }\n\n      .answer {\n        font-size: 16px;\n\n        .paragraph {\n          margin-bottom: 8px;\n        }\n  \n        .listItem {\n          margin-bottom: 8px;\n        }\n  \n        .help {\n          gap: 16px;\n        }\n      }\n    }\n  }\n}\n\n.no_padding_top {\n  padding-top: 0;\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n// New fonts\n\n@mixin header1 {\n  font-size: 56px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header3 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header4 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin header5 {\n  font-size: 28px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1 {\n  font-size: 24px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle2 {\n  font-size: 20px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle3 {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin subtitle4 {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonLarge {\n  font-size: 16px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonMedium {\n  font-size: 14px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin buttonSmall {\n  font-size: 13px;\n  font-weight: 600;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 12px;\n  font-weight: 600;\n  font-style: normal;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Faq_container__4PRrc`,
	"title": `Faq_title__-bl5+`,
	"item": `Faq_item__wsIel`,
	"question": `Faq_question__kKoqd`,
	"arrow": `Faq_arrow__2io+B`,
	"active": `Faq_active__Kzfgu`,
	"answer": `Faq_answer__BWCvA`,
	"help": `Faq_help__e-GaN`,
	"tg": `Faq_tg__u+o5S`,
	"phone": `Faq_phone__IAL6W`,
	"rockets": `Faq_rockets__o8yDx`,
	"open": `Faq_open__KX1f5`,
	"link": `Faq_link__BqmOc`,
	"listItem": `Faq_listItem__1Pbv-`,
	"listImg": `Faq_listImg__MDkiq`,
	"listItemBig": `Faq_listItemBig__BHEMI`,
	"paragraph": `Faq_paragraph__bJ-rb`,
	"no_padding_top": `Faq_no_padding_top__SIfi3`
};
export default ___CSS_LOADER_EXPORT___;
